import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { RxwebValidators } from "@rxweb/reactive-form-validators";

/**VALIDATORS */

export function emailValidator(control: AbstractControl): ValidationErrors | null {
    return RxwebValidators.email()(control);
}

export function IpValidator(control: AbstractControl): ValidationErrors | null {
    return !control.value || /(\d{1,3}\.){3}\d{1,3}/.test(control.value) ? null : { ip: true };
}

export function ssnValidator(control: AbstractControl): ValidationErrors | null {
    //  return !control.value || /^\d{3}-\d{2}-\d{4}/.test(control.value) ? null : { ssn: true };
     return !control.value || /^[\d*]{3}-[\d*]{2}-[\d*]{4}$/.test(control.value) ? null : { ssn: true };
}


/**VALIDATION MESSAGES */
export function minLengthValidationMessage(error: any, field: FormlyFieldConfig) {
    return `Should have atleast ${field?.props?.minLength} characters`;
}

export function maxLengthValidationMessage(error: any, field: FormlyFieldConfig) {
    return `This value should be less than ${field?.props?.maxLength} characters`;
}

export function minValidationMessage(error: any, field: FormlyFieldConfig) {
    return `This value should be more than ${field?.props?.min}`;
}

export function maxValidationMessage(error: any, field: FormlyFieldConfig) {
    return `This value should be less than ${field?.props?.max}`;
}

export function invalidEmailMessage(error: any, field: FormlyFieldConfig) {
    return `Email is not valid.`;
}

export function invalidSSN(error: any, field: FormlyFieldConfig) {
    return `SSN # is not valid.`;
}